// extracted by mini-css-extract-plugin
module.exports = {"imgOverlay":"imgoverlay_imgOverlay__1UxuI index_tac__SFlCr","darken":"imgoverlay_darken__4fnN6","body":"imgoverlay_body__ry5hm","txt":"imgoverlay_txt__leGun"};